import documentsService from '@/services/documents.service'

export default {
  namespaced: true,
  state: {
    documents: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_DOCUMENTS(state, documents) {
      state.documents = documents
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    ADD_DOCUMENT(state, document) {
      state.documents.push(document)
    },
    UPDATE_DOCUMENT(state, updatedDocument) {
      const index = state.documents.findIndex(d => d.id === updatedDocument.id)
      if (index !== -1) {
        state.documents.splice(index, 1, updatedDocument)
      }
    },
    REMOVE_DOCUMENT(state, id) {
      state.documents = state.documents.filter(d => d.id !== id)
    }
  },
  actions: {
    async fetchByUserId({ commit }, userId) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await documentsService.getByUserId(userId)
        const documents = response.data?.data || response.data || []
        commit('SET_DOCUMENTS', documents)
        return { success: true, data: documents }
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createDocument({ commit }, documentData) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await documentsService.create(documentData)
        if (response.success) {
          commit('ADD_DOCUMENT', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateDocument({ commit }, { id, documentData }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await documentsService.update(id, documentData)
        if (response.success) {
          commit('UPDATE_DOCUMENT', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteDocument({ commit }, id) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await documentsService.delete(id)
        if (response.success) {
          commit('REMOVE_DOCUMENT', id)
          return { success: true }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async downloadDocument(_, id) {
      try {
        const response = await documentsService.download(id)
        return { success: true, data: response }
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        return { success: false, error: errorMessage }
      }
    },

    clearDocuments({ commit }) {
      commit('SET_DOCUMENTS', [])
      commit('SET_ERROR', null)
    }
  },
  getters: {
    allDocuments: state => state.documents,
    isLoading: state => state.loading,
    error: state => state.error
  }
}

